import { RouteConfig } from 'vue-router'
import { requireAuthAndLocation } from '../../auth'

const NewProposalsEstimates = () =>
    import('@/pmd/pages/payments/NewProposalsEstimates.vue')
  

export const DocumentsContractsBuilderRoute: RouteConfig[] = [
    {
        path: 'payments/proposals-estimates/edit/:id',
        name: 'proposals-estimates-edit',
        component: NewProposalsEstimates,
        beforeEnter: requireAuthAndLocation,
        children: [],
        meta: {
            hideSideBar: true,
            hideTopBar: true,
        },
    },
]
